let _initProto, _initClass, _init_label, _init_extra_label;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, onEvent, prop } from "@ecopages/radiant";
import { queryRovingTabindexItems } from "@/lib/focusable-elements";
import { applyRovingTabindex, navigateRovingTabindex } from "@/lib/roving-tabindex";
let _RuiNavigationMenu;
class RuiNavigationMenu extends RadiantElement {
  static {
    ({
      e: [_init_label, _init_extra_label, _initProto],
      c: [_RuiNavigationMenu, _initClass]
    } = _applyDecs(this, [customElement("rui-navigation-menu")], [[prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [onEvent({
      document: true,
      type: "click"
    }), 2, "onDocumentClick"], [onEvent({
      document: true,
      type: "keydown"
    }), 2, "onDocumentKeydown"], [onEvent({
      ref: "root",
      type: "keydown"
    }), 2, "onRootKeydown"], [onEvent({
      selector: "[data-navigation-trigger]",
      type: "click"
    }), 2, "onTriggerClick"], [onEvent({
      selector: "[data-navigation-item]",
      type: "keydown"
    }), 2, "onBarItemKeydown"], [onEvent({
      selector: "[data-navigation-panel]",
      type: "keydown"
    }), 2, "onPanelKeydown"]], 0, void 0, RadiantElement));
  }
  label = (_initProto(this), _init_label(this));
  openValue = (_init_extra_label(this), null);
  onConnected() {
    this.syncPanels();
    this.syncBarRovingTabindex();
  }
  getBarItems() {
    return Array.from(this.querySelectorAll("[data-navigation-item]"));
  }
  syncBarRovingTabindex() {
    const items = this.getBarItems();
    const activeIndex = Math.max(0, items.findIndex(item => item.tabIndex === 0 || item === document.activeElement));
    applyRovingTabindex(items, activeIndex);
  }
  isBarTrigger(item) {
    return item.hasAttribute("data-navigation-trigger");
  }
  getTriggers() {
    return Array.from(this.querySelectorAll("[data-navigation-trigger]"));
  }
  getPanel(value) {
    return this.querySelector(`[data-navigation-panel][data-value="${value}"]`);
  }
  getTrigger(value) {
    return this.querySelector(`[data-navigation-trigger][data-value="${value}"]`);
  }
  getPanels() {
    return Array.from(this.querySelectorAll("[data-navigation-panel]"));
  }
  getPanelFocusables(panel) {
    return queryRovingTabindexItems(panel);
  }
  focusPanelEntry(value) {
    const panel = this.getPanel(value);
    if (!panel) {
      this.getTrigger(value)?.focus();
      return;
    }
    const focusables = this.getPanelFocusables(panel);
    if (focusables.length > 0) {
      focusables[0].focus();
      return;
    }
    if (!panel.hasAttribute("tabindex")) {
      panel.tabIndex = -1;
    }
    panel.focus();
  }
  syncPanels() {
    for (const panel of this.getPanels()) {
      const value = panel.getAttribute("data-value") ?? "";
      const open = this.openValue === value;
      panel.toggleAttribute("hidden", !open);
      panel.dataset.state = open ? "open" : "closed";
      panel.setAttribute("aria-hidden", String(!open));
      const trigger = this.getTrigger(value);
      if (trigger) {
        trigger.setAttribute("aria-expanded", String(open));
        panel.setAttribute("role", "region");
        panel.setAttribute("aria-labelledby", trigger.id || `${value}-trigger`);
        if (!trigger.id) {
          trigger.id = `${value}-trigger`;
        }
      }
    }
    for (const trigger of this.getTriggers()) {
      const value = trigger.getAttribute("data-value") ?? "";
      const open = this.openValue === value;
      trigger.setAttribute("aria-expanded", String(open));
      if (this.getPanel(value)) {
        trigger.setAttribute("aria-haspopup", "true");
      } else {
        trigger.removeAttribute("aria-haspopup");
      }
    }
  }
  closeMenu(returnFocus = false) {
    const previous = this.openValue;
    if (!previous) {
      return;
    }
    this.openValue = null;
    this.syncPanels();
    if (returnFocus) {
      this.getTrigger(previous)?.focus();
    }
  }
  openPanel(value, focusPanel = true) {
    if (this.openValue === value) {
      this.closeMenu(true);
      return;
    }
    this.openValue = value;
    this.syncPanels();
    queueMicrotask(() => {
      if (focusPanel) {
        this.focusPanelEntry(value);
      } else {
        this.getTrigger(value)?.focus();
      }
    });
  }
  getEventElement(event) {
    const target = event.target;
    if (target instanceof Element) {
      return target;
    }
    if (target instanceof Text) {
      return target.parentElement;
    }
    return null;
  }
  isWithinOpenPanel(event) {
    if (!this.openValue) {
      return false;
    }
    const openPanel = this.getPanel(this.openValue);
    if (!openPanel) {
      return false;
    }
    return event.composedPath().some(node => node instanceof Node && openPanel.contains(node));
  }
  onDocumentClick(event) {
    if (!this.openValue) {
      return;
    }
    if (this.isWithinOpenPanel(event)) {
      return;
    }
    const element = this.getEventElement(event);
    if (element && this.contains(element)) {
      return;
    }
    this.closeMenu();
  }
  onDocumentKeydown(event) {
    if (event.key !== "Escape" || !this.openValue) {
      return;
    }
    const active = document.activeElement;
    if (active && !this.contains(active)) {
      return;
    }
    event.preventDefault();
    this.closeMenu(true);
  }
  onRootKeydown(event) {
    if (event.key === "Escape" && this.openValue) {
      event.preventDefault();
      this.closeMenu(true);
    }
  }
  onTriggerClick(event) {
    const trigger = event.target.closest("[data-navigation-trigger]");
    const value = trigger?.getAttribute("data-value");
    if (!trigger || !value) {
      return;
    }
    event.preventDefault();
    this.openPanel(value);
  }
  onBarItemKeydown(event) {
    const item = event.target.closest("[data-navigation-item]");
    if (!item) {
      return;
    }
    const barItems = this.getBarItems();
    const isTrigger = this.isBarTrigger(item);
    const value = item.getAttribute("data-value");
    if (event.key === "Escape") {
      if (this.openValue) {
        event.preventDefault();
        this.closeMenu(true);
      }
      return;
    }
    if (isTrigger && value && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      this.openPanel(value);
      return;
    }
    if (isTrigger && value && event.key === "ArrowDown") {
      event.preventDefault();
      if (this.openValue === value) {
        this.focusPanelEntry(value);
      } else {
        this.openPanel(value);
      }
      return;
    }
    const result = navigateRovingTabindex({
      items: barItems,
      current: item,
      key: event.key,
      orientation: "horizontal",
      wrap: false
    });
    if (!result.handled) {
      return;
    }
    event.preventDefault();
    const nextItem = result.item;
    const nextValue = nextItem.getAttribute("data-value");
    const nextIsTrigger = this.isBarTrigger(nextItem);
    if (this.openValue) {
      if (nextIsTrigger && nextValue) {
        this.openPanel(nextValue);
      } else {
        this.closeMenu(false);
      }
    }
  }
  onPanelKeydown(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }
    const panel = target.closest("[data-navigation-panel]");
    if (!panel || panel.hidden) {
      return;
    }
    const value = panel.getAttribute("data-value");
    if (!value || this.openValue !== value) {
      return;
    }
    const active = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    if (!active || !panel.contains(active)) {
      return;
    }
    if (event.key === "Escape") {
      event.preventDefault();
      this.closeMenu(true);
      return;
    }
    const focusables = this.getPanelFocusables(panel);
    if (event.key === "ArrowUp" && active === focusables[0]) {
      event.preventDefault();
      this.getTrigger(value)?.focus();
      return;
    }
    if (!focusables.length) {
      return;
    }
    const result = navigateRovingTabindex({
      items: focusables,
      current: active,
      key: event.key,
      orientation: "vertical",
      wrap: false
    });
    if (!result.handled) {
      return;
    }
    event.preventDefault();
  }
  static {
    _initClass();
  }
}
export { _RuiNavigationMenu as RuiNavigationMenu };